var exports = {
  "k": "xfd349460--8a3118--container",
  "K": "xfd349460--8a3118--icon",
};

module.exports = exports;
